import React from "react"
import PropTypes from "prop-types"
import { useFocusOnErrors } from "QuorumGrassroots/widgets/ReusableComponents/UserInfoFormSection/hooks/useFocusOnErrors"

/**
 * A wrapper component that adds focus-on-error functionality to forms
 */
export const ErrorFocusWrapper = ({
    children,
    syncErrors,
    invalid,
    submitFailed,
    submitting,
    formSelector,
    submitButtonSelectors,
    externalSubmitButtonSelectors,
    className,
    style,
}) => {
    const containerRef = useFocusOnErrors({
        syncErrors,
        invalid,
        submitFailed,
        submitting,
        formSelector,
        submitButtonSelectors,
        externalSubmitButtonSelectors,
    })

    return (
        <div ref={containerRef} className={className} style={style}>
            {children}
        </div>
    )
}

ErrorFocusWrapper.propTypes = {
    children: PropTypes.node.isRequired,
    syncErrors: PropTypes.object,
    invalid: PropTypes.bool,
    submitFailed: PropTypes.bool,
    submitting: PropTypes.bool,
    formSelector: PropTypes.string,
    submitButtonSelectors: PropTypes.arrayOf(PropTypes.string),
    externalSubmitButtonSelectors: PropTypes.arrayOf(PropTypes.string),
    className: PropTypes.string,
    style: PropTypes.object,
}

export default ErrorFocusWrapper
